import { getLandingSource, landingScope, applyLandingPixel, resolveLandingPixel } from '../utils/landingAttribution'
import { reportPwaFirstOpen } from '../utils/pwaRuntime'
import { prepareMetaPixel, configureMetaPixel, trackMetaEvent } from '../utils/metaPixel'
import { reportDeposits } from '../utils/reportDeposits'
/*eslint-disable*/
import * as types from './mutation-types';
import $Cookies from 'js-cookie';
import $qs from 'qs';
import Adjust from '@adjustcom/adjust-web-sdk'
import { callBackBuried , queryListBuried , updateBuried} from '@/common/api/bindAuthenticate.js'
import { inviteInfo } from '@/common/api/team.js'


export const Login = function ({commit, state}, UUID) {
  commit(types.LOGIN,UUID)
};

export const checkLogin = function ({commit, state}, uuids) {

  let url = window.location.href;
  let UUID = $qs.parse(url.split('?')[1]).UUID;

  if (UUID === undefined) {
    UUID = $Cookies.get('UUID') || uuids
  } else {
    $Cookies.set('UUID', UUID)
  }

  // let UUID = $Cookies.get('UUID');

  let obj = {};
  if(UUID) {
    obj['isLogin'] = true;
    obj['UUID'] = UUID;
    commit(types.CHECK_LOGIN, obj)
  }else {
    commit(types.LOGIN_OUT)
  }

};

// 是否竖屏横屏
export const check_isHorizontal = function({commit, state}) {
  let bool = false;
  if(window.orientation===180||window.orientation===0){
    bool = false;
  }
  if(window.orientation===90||window.orientation===-90){
    bool = true;
  }
  commit('set_isHorizontal',bool)
}


// new 802及以后
function loadJsCode(code){
  let script = document.createElement('script');
  script.type = 'text/javascript';
  //for Chrome Firefox Opera Safari
  script.appendChild(document.createTextNode(code));
  //for IE
  //script.text = code;
  document.head.appendChild(script);
}
function loadnoscript(iframeSrc){
  let noscript = document.createElement('noscript');
  let iframe  = document.createElement('iframe');
  iframe.src  = iframeSrc;
  iframe.height = 1;
  iframe.width = 1;
  iframe.style = 'display:none';
  noscript.appendChild(iframe)
  document.body.appendChild(noscript);
}
import { refresh, initSystem, getFrontConfig, getUserInfo, logout } from '@/common/api/system.js'
import { getBrowserInfo } from '@/common/utils/common.js'
import { getAgentCode } from '@/common/utils/initRegisterAgentCode.js'
import { getCollectIds } from '@/common/api/game.js'
import { takebackAmount, refreshGameAccount } from '@/common/api/Amount.js'

// 游客获取服务器信息
let initRequest = null
let initParamsKey = ''
let initVersion = 0
const configuredTrackers = {}
let retryInitContext = null
// Retry on reconnect/tab return, without a timer loop. Requests still coalesce.
const resumeInit = () => {
  if (!retryInitContext || document.visibilityState === 'hidden') return
  const context = retryInitContext
  initSystemInfo(context).then(config => {
    if (config && !config.metaTrackingPending && context.state.isLogin && context.dispatch) {
      context.dispatch('reportDepositEvents')
    }
  })
}
if (typeof window.addEventListener === 'function') {
  window.addEventListener('online', resumeInit)
  window.addEventListener('pageshow', resumeInit)
}
if (typeof document.addEventListener === 'function') document.addEventListener('visibilitychange', resumeInit)
export const initSystemInfo = function(context) {
  const { commit, state } = context
  // Resolve parameters synchronously before routing or registration initialization.
  const params = { agentCode: getAgentCode({ commit, state }) }
  const source = getLandingSource()
  const scope = landingScope(source) || 'site:' + window.location.origin + ':' + params.agentCode
  const requestKey = JSON.stringify([params, source && source.visitId])
  if (initRequest && initParamsKey === requestKey) return initRequest
  initParamsKey = requestKey
  const version = ++initVersion
  prepareMetaPixel(scope)
  initRequest = initSystem(params).then(response => {
    let [data, err, res] = response
    if (version !== initVersion) return null
    if (!err){
      if (!data || typeof data !== 'object') throw new Error('Invalid init response')
      data = applyLandingPixel(data, source)
      if (source) resolveLandingPixel(source, data.pageBuryingId)
      retryInitContext = null
      configureMetaPixel(data.pageBuryingId, scope)
      reportPwaFirstOpen(data.pageBuryingId)
      const googleKey = 'google:' + data.googleType + ':' + data.googleId
      if(!!data.googleType && !!data.googleId && !configuredTrackers[googleKey]){
        if(data.googleType == 10){//gtag
          // Init may complete after window.load; load directly without replacing its handler.
          let script = document.createElement('script');
          script.type = 'text/javascript';
          script.src = 'https://www.googletagmanager.com/gtag/js?id=' + encodeURIComponent(data.googleId);
          script.async = true;
          document.head.appendChild(script);
          loadJsCode(`window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
        
          gtag('config', ${JSON.stringify(String(data.googleId))});`);
        }else if(data.googleType == 20){//gtm
          loadJsCode(`(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
          new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
          j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
          'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
          })(window,document,'script','dataLayer','${data.googleId}');`);
        }
        configuredTrackers[googleKey] = true
      }
      const sharechatKey = 'sharechat:' + data.sharechatId
      if(data.sharechatId && !configuredTrackers[sharechatKey]){
        loadJsCode(`(function (w, d, s, l, i) {
          w['scSdkId'] = i;
          w[l] = w[l] || []
          w.scq = function (eventName, eventType, p) {
          var props = p || {}
            w[l].push({ eventName: eventName, eventType: eventType, meta: props, eventFireTs: Date.now() })
          };
          w.scq("PAGE_VIEW", "AUTO", {
            pageUrl: w.location.href
          });
          var scr = d.createElement(s);
          scr.type = 'text/javascript';
          scr.async = true;
          scr.src = 'https://sc-events-sdk.sharechat.com/web-sdk.js';
          var x = d.getElementsByTagName(s)[0];
          x.parentNode.insertBefore(scr, x);
        })(window, document, "script", "scLayer", ${JSON.stringify(data.sharechatId)});`);
        configuredTrackers[sharechatKey] = true
      }
      if(!!data.snapPixelId){
        loadJsCode(`(function(e,t,n){if(e.snaptr)return;var a=e.snaptr=function()
          {a.handleRequest?a.handleRequest.apply(a,arguments):a.queue.push(arguments)};
          a.queue=[];var s='script';r=t.createElement(s);r.async=!0;
          r.src=n;var u=t.getElementsByTagName(s)[0];
          u.parentNode.insertBefore(r,u);})(window,document,
          'https://sc-static.net/scevent.min.js');
          
          snaptr('init', '${data.snapPixelId}', {
          'user_email': 'INSERT_USER_EMAIL'
          });
          
          snaptr('track', 'PAGE_VIEW');`);
      }
      commit(types.INIT_LIST, data)
      return data
    }
    initRequest = null
    retryInitContext = context
    return null
  }).catch(() => {
    if (version === initVersion) { initRequest = null; retryInitContext = context }
    return null
  })
  return initRequest
}

// 代理联系方式
export const connactLists = function({ commit, state }) {
  getFrontConfig({}).then(([data, err, res]) => {
    if (!err) commit(types.FRONTCONFIG_LIST,data)
  })
}


// 获取用户信息
export const refreshUserInfo = function({ commit, state, dispatch }, type = 0) { // 0 刷新用户信息使用 1 登录使用
  const params = { domain: document.domain, ipInfo: '' }
  if ($Cookies.get('UUID')) {
    params.UUID = $Cookies.get('UUID')
    commit(types.LOGIN, params.UUID)
  } else {
    return
  }
  params.browser = getBrowserInfo()[0]//取到完整信息
  params.deviceId = $Cookies.get('deviceId')
  if(params.deviceId === undefined || params.deviceId===''){
    let timeStr = new Date().getTime().toString()
    let str = Math.random().toString().slice(-6)
    params.deviceId = timeStr + str
    $Cookies.set('deviceId', params.deviceId, { expires: 2000 })
  }
  getUserInfo(params, type).then(([data, err, res]) => {
    if(res && res.data && res.data.code == 998) commit('SET_FORCE_CHANGE_PASSWORD', true);
    if (!err) {
      if (state.refreshAccount) {
        let timer = setTimeout(() => {
          commit(types.SET_USER_INFO, data)
          commit('setRefreshAccount', false) // 重置刷新账户余额状态完成
          clearTimeout(timer)
        }, 1500)
      } else {
        commit(types.SET_USER_INFO, data)
      }
      if(type == 1){
          // 没有填写手机  弹框
        data.userInfo.mobilePhone == '' || data.userInfo.mobilePhone == null?commit('setshowBindphone',true):commit('setshowBindphone',false)
      }
      
      // 首存查询
      dispatch('reportDepositEvents')

      inviteInfo({UUID: $Cookies.get('UUID')}).then(([data, err]) => {
        if (!err) {
          const { buttonDisplay , buttonStatus , claimedBonus } = data
          commit('setInviteInfo', {claimedBonus,buttonStatus,buttonDisplay})
        }
      })
    } else {
      commit('setRefreshAccount', false)
    }
  })
}

// 刷新账户余额 type 1 = 刷新账户余额  2 = 取出全部的金额，用于提现等页面 isHand 标识是否手动
export const refreshAccount = function({ commit, state, dispatch }, param = {}) {
  const { type, isHand, router } = Object.assign({}, { type: 1, isHand: true }, param)
  if (!$Cookies.get('UUID')) {
    if (isHand) {
      if (!document.getElementById('popupLogin')) { // 判断是否为弹起的登录 页面登录
        if (router) router.push({ path: '/login' })
      } else { // 弹起登录
        commit('SET_LOGIN_SHOW')
      }
    }
    return
  }
  if (state.refreshAccount) return
  if (isHand) commit('setRefreshAccount', true) // 重置刷新账户余额状态进行
  let _ajax = null
  if (type === 1) _ajax = refreshGameAccount
  if (type === 2) _ajax = takebackAmount
  if (!_ajax) return
  _ajax({ UUID: $Cookies.get('UUID') }).then(([data, err, res]) => {
    if (!err) {
	  if (param.fn) param.fn()
      refreshUserInfo({ commit, state, dispatch }, 0)
    } else {
      commit('setRefreshAccount', false)
    }
  })
}

// 退出登录
export const Logout = function({ commit, state }, uuid) {
  if (!$Cookies.get('UUID')) return
  return new Promise((resolve, reject) => {
    logout({ UUID: uuid || $Cookies.get('UUID') }).then(([data, err, res]) => {
      if (!err) {
        commit('LOGIN_OUT')
        resolve(true)
      } else {
        reject(res.data.msg)
      }
    })
  })
}


// Configuration must arrive before consuming the backend reporting flags.
export const reportDepositEvents = function ({ dispatch, state }) {
  const UUID = $Cookies.get('UUID')
  if (!UUID) return
  return dispatch('initSystemInfo').then(config => {
    if (!config || $Cookies.get('UUID') !== UUID) return
    return reportDeposits({ UUID, config, query: queryListBuried, update: updateBuried, app: true })
  })
}

export const reportRegistration = function ({ dispatch }) {
  dispatch('initSystemInfo')
  return trackMetaEvent('CompleteRegistration')
}



// WEBPACK FOOTER //
// ./src/common/store/actions.js